import { FeatureFlag } from '../FeatureFlag';

export const enableNewManualReviewColumns = new FeatureFlag({
    key: 'enable-new-manual-review-columns',
    defaultValue: false,
});
